export default function TermsConditions() {
    return (
        <div className="w-full bg-white">
            <div className="max-w-5xl mx-auto px-6 py-14">

                {/* PAGE TITLE */}
                <h1 className="text-3xl font-extrabold text-gray-900 mb-6">
                    Terms & Conditions
                </h1>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Welcome to <strong>BlogySports</strong>. By accessing and using this
                    website, you agree to comply with and be bound by the following Terms
                    and Conditions. Please read them carefully before using our platform.
                </p>

                {/* USE OF WEBSITE */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Use of the Website
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    BlogySports provides sports news, match updates, analysis, opinions,
                    and informational content for general knowledge and entertainment
                    purposes. You agree to use this website lawfully and not engage in any
                    activity that may harm, disrupt, or misuse the platform or its content.
                </p>

                {/* CONTENT ACCURACY */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Content Accuracy
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    While we strive to provide accurate and up-to-date sports information,
                    BlogySports does not guarantee the completeness, accuracy, or
                    reliability of any content. Match results, statistics, and news may
                    change, and users should verify information independently when
                    necessary.
                </p>

                {/* INTELLECTUAL PROPERTY */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Intellectual Property Rights
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    All content on BlogySports, including articles, images, graphics,
                    logos, and design elements, is the intellectual property of
                    BlogySports unless otherwise stated. Unauthorized copying,
                    reproduction, or redistribution of content is strictly prohibited
                    without prior written permission.
                </p>

                {/* THIRD-PARTY LINKS */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Third-Party Links
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    BlogySports may contain links to external websites for reference,
                    sources, or convenience. We do not control or take responsibility for
                    the content, policies, or practices of third-party websites. Visiting
                    such links is at your own discretion and risk.
                </p>

                {/* ADVERTISING */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Advertising & Affiliate Disclosure
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    BlogySports may display advertisements from third-party advertising
                    partners, including Google AdSense. These advertisements help support
                    the operation of the website. We do not endorse or guarantee any
                    products or services advertised unless explicitly stated.
                </p>

                {/* LIMITATION OF LIABILITY */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Limitation of Liability
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    BlogySports shall not be held liable for any direct, indirect,
                    incidental, or consequential damages arising from the use of this
                    website or reliance on its content. This includes loss of data,
                    revenue, or opportunities resulting from sports outcomes or
                    information.
                </p>

                {/* USER RESPONSIBILITY */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    User Responsibilities
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Users are responsible for their actions when accessing BlogySports.
                    You agree not to misuse the website, post harmful content, attempt
                    unauthorized access, or engage in activities that violate applicable
                    laws or regulations.
                </p>

                {/* TERMINATION */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Termination of Access
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    We reserve the right to restrict or terminate access to BlogySports,
                    without notice, if a user violates these Terms & Conditions or engages
                    in behavior that is harmful to the platform or its users.
                </p>

                {/* CHANGES */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Changes to These Terms
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    BlogySports may update these Terms & Conditions periodically. Any
                    changes will be reflected on this page and will become effective
                    immediately upon publication.
                </p>

                {/* GOVERNING LAW */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Governing Law
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    These Terms & Conditions shall be governed and interpreted in
                    accordance with applicable laws. Any disputes related to the use of
                    BlogySports shall fall under the appropriate legal jurisdiction.
                </p>

                {/* CONTACT */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Contact Information
                </h2>

                <p className="text-gray-700 leading-relaxed mb-10">
                    If you have any questions regarding these Terms & Conditions, please
                    contact us at <strong>contact@blogysports.com</strong>.
                </p>

                <p className="text-sm text-gray-500">
                    Last updated: {new Date().toLocaleDateString("en-IN")}
                </p>

            </div>
        </div>
    );
}
